var path = 'app/components/common/crud/list/listActions.html';
var html = "<span compile=\"customTemplate\"><span ng-repeat=\"button in ::buttons\" ng-switch=\"button\"><ma-show-button ng-switch-when=\"show\" entry=\"::entry\" entity=\"::entity\" size=\"xs\"></ma-show-button><a ng-click=\"edit()\" ng-switch-when=\"edit\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-edit\"></i></a> <a ng-click=\"delete()\" ng-switch-when=\"delete\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-close\"></i></a><span ng-switch-default><span compile=\"button\"></span></span></span></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/crud/list/listActions.html
// module id = 494
// module chunks = 0